import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid/Grid';
import moment from 'moment';

import '../css/xmas.css';

const styles = {
    container: {
        color: '#FFFFFF',
    },
    title: {
        fontFamily: 'xmas1',
        textAlign: 'center',
        fontSize: 54,
        textShadow: '-1px 0 black, 0 3px black, 1px 0 black, 0 -1px black',
        fontWeight: 200,
    },
    timeTitle: {
        marginTop: 8,
        fontSize: 22,
        fontFamily: 'xmas1',
        textShadow: '-1px 0 black, 0 2px black, 1px 0 black, 0 -1px black',
    },
    time: {
        textShadow: '-1px 0 black, 0 1px black, 1px 0 black, 0 -1px black',
        fontSize: 64,
    }
};

class Counter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
        };
    }

    componentWillMount() {
        this.state.interval = setInterval(this.tick, 1000)
    }

    componentWillUnmount() {
        this.state.interval && clearInterval(this.state.interval);
    }

    tick = () => {

        const stateUpdate = {};
        // const now = moment(); // today's date
        // const end = moment(this.props.endDate); // end date
        // const duration = moment.duration(end.diff(now));

        const end = moment(this.props.endDate, 'DD-MM-YYYY HH:mm:ss').unix();
        const now = moment().unix();
        // diffTime = eventTime - currentTime,
        const duration = moment.duration((end - now) * 1000, 'milliseconds');

        if (duration.asSeconds() >= 0) {
            if (Math.floor(duration.asDays()) > 0) {
                let days = Math.floor(duration.asDays());
                if (days < 10) {
                    stateUpdate.days = '0' + days;
                } else {
                    stateUpdate.days = days;
                }
            }
            if (Math.floor(duration.asHours()) > 0) {
                if (Math.floor(duration.hours()) < 10) {
                    stateUpdate.hours = '0' + Math.floor(duration.hours());
                } else {
                    stateUpdate.hours = Math.floor(duration.hours());
                }
            }
            if (Math.floor(duration.asMinutes()) > 0) {
                if (Math.floor(duration.minutes()) < 10) {
                    stateUpdate.minutes = '0' + Math.floor(duration.minutes());
                } else {
                    stateUpdate.minutes = Math.floor(duration.minutes());
                }
            }
            if (Math.floor(duration.asSeconds()) > 0) {
                if (Math.floor(duration.seconds()) < 10) {
                    stateUpdate.seconds = '0' + Math.floor(duration.seconds());
                } else {
                    stateUpdate.seconds = Math.floor(duration.seconds());
                }
            }
        }
        this.setState(stateUpdate);
    };

    render() {
        const {classes} = this.props;

        return (
            <Grid
                container
                style={this.props.style}
                className={classes.container}
            >
                <Grid
                    item
                    xs={12}
                    className={classes.title}
                >
                    Merry Christmas
                </Grid>
                <Grid item xs={3}>
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                    >
                        <Grid
                            item
                            className={classes.time}
                        >
                            {this.state.days}
                        </Grid>
                        <Grid
                            item
                            className={classes.timeTitle}
                        >
                            Days
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={3}>
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                    >
                        <Grid
                            item
                            className={classes.time}
                        >
                            {this.state.hours}
                        </Grid>
                        <Grid
                            item
                            className={classes.timeTitle}
                        >
                            Hours
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={3}>
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                    >
                        <Grid
                            item
                            className={classes.time}
                        >
                            {this.state.minutes}
                        </Grid>
                        <Grid
                            item
                            className={classes.timeTitle}
                        >
                            Minutes
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={3}>
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                    >
                        <Grid
                            item
                            className={classes.time}
                        >
                            {this.state.seconds}
                        </Grid>
                        <Grid
                            item
                            className={classes.timeTitle}
                        >
                            Seconds
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

Counter.defaultProps = {
    endDate: '24-12-2019 24:00:00',
    displayMonth: false,
};

Counter.propTypes = {
    endDate: PropTypes.string,
    displayMonth: PropTypes.bool,
};

export default withStyles(styles)(Counter);



// WEBPACK FOOTER //
// ./src/components/Counter.jsx